import React, { Component } from "react";
import {
  Row,
  InternalImage,
  ExternalImage,
  Wrapper,
  Icon
} from "app/NativeComponents/common";

class Logos extends Component {
  render() {
    if (this.props.partner) {
      if (this.props.partner != "" && this.props.partner_logo_white != "") {
        return (
          <Row>
            <InternalImage
              style={{
                height: 60,
                marginBottom: 0,
                marginLeft: 10,
                width: 110,
                objectFit: "contain",
                alignItems: "center",
                justifyContent: "flex-start"
              }}
              contain
              image={"/assets/images/dm_white_logo_medium.png"}
            />
            <Wrapper
              style={{
                width: 30,
                height: 60,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Icon color="#fff" icon="add" size={20} />
            </Wrapper>
            <ExternalImage
              style={{
                height: 60,
                marginBottom: 0,
                width: 110,
                objectFit: "contain",
                alignItems: "center",
                justifyContent: "flex-start"
              }}
              contain
              image={this.props.partner_logo_white}
            />
          </Row>
        );
      }
    }
    return (
      <InternalImage
        style={{
          height: 60,
          marginBottom: 0,
          width: 130,
          marginLeft: 10,

          objectFit: "contain",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
        contain
        image={"/assets/images/dm_white_logo_medium.png"}
      />
    );
  }
}

export default Logos;
